package uz.mint.frontend.pages.en

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import uz.mint.frontend.components.layouts.PageLayoutData
import uz.mint.frontend.components.sections.ProfilePage
import uz.mint.frontend.i18n.Locale
import uz.mint.frontend.i18n.accountStringsFor

/** Profile in English, at /en/profile. */
private val LOCALE = Locale.EN

@InitRoute
fun initEnProfileRoutePage(ctx: InitRouteContext) {
    val account = accountStringsFor(LOCALE)
    ctx.data.add(PageLayoutData(account.profileMetaTitle, LOCALE, account.profileMetaDescription))
}

@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun EnProfileRoutePage() {
    ProfilePage(LOCALE)
}
